import React, { useState } from "react";
import { Linking, Text } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { CheckBox } from "../formElements/CheckBox";
import { GlobalStyles } from "../style/Style";

type Argreements = {
    privacy: boolean;
    terms: boolean;
    age: boolean;
};

export type UseAgreementsReturnProps = {
    agreementsTag: JSX.Element;
    allAgreementsAccepted: boolean;
};

export const useAgreements = (): UseAgreementsReturnProps => {
    const [agreementState, setAgreementState] = useState<Argreements>({ privacy: false, terms: false, age: false });
    const styles = useDynamicStyles(generateStyles);

    const privacyPolicyLabel = (
        <>
            <Text style={styles.label}>
                I agree to the{" "}
                <Text
                    onPress={() => Linking.openURL("https://freeplay.twinspires.com/privacy-policy")}
                    style={[styles.link]}
                >
                    Privacy Policy
                </Text>
            </Text>
        </>
    );

    const termsLabel = (
        <>
            <Text style={styles.label}>
                I agree to the{" "}
                <Text
                    onPress={() => Linking.openURL("https://freeplay.twinspires.com/terms-conditions")}
                    style={[styles.link]}
                >
                    Terms & Conditions
                </Text>
            </Text>
        </>
    );

    const agreementsTag = (
        <>
            <CheckBox
                labelOverride={privacyPolicyLabel}
                checked={agreementState.privacy}
                onChange={() => setAgreementState({ ...agreementState, privacy: !agreementState.privacy })}
            />
            <CheckBox
                labelOverride={termsLabel}
                checked={agreementState.terms}
                onChange={() => setAgreementState({ ...agreementState, terms: !agreementState.terms })}
            />
            <CheckBox
                title={"I confirm that I am 21 years of age or older."}
                checked={agreementState.age}
                onChange={() => setAgreementState({ ...agreementState, age: !agreementState.age })}
            />
        </>
    );

    return {
        agreementsTag,
        allAgreementsAccepted: agreementState.age && agreementState.privacy && agreementState.terms,
    };
};

const generateStyles = () => {
    return EStyleSheet.create({
        label: {
            fontSize: 14,
            paddingLeft: 10,
            fontWeight: "600",
            color: () => EStyleSheet.value(GlobalStyles.BASE_COLOUR),
            fontFamily: () => EStyleSheet.value(GlobalStyles.BASE_FONT),
        },
        link: {
            color: () => EStyleSheet.value(GlobalStyles.ACCENT_COLOUR),
        },
    });
};
